import { createContext, useContext } from "react";

export const BRANDS = {
  folketstrom: {
    id: "folketstrom",
    cssClass: "",
    name: "Folketstrøm",
    companyLine: "Folketstrøm AS",
    wordmarkTop: "FOLKET",
    wordmarkAccent: "STRØM",
    tagline: "Strøm på dine vilkår",
    title: "Folketstrøm AS | Strøm på dine vilkår – Fornybar energi til bedrifter",
    description:
      "Folketstrøm AS leverer Flexsikring – spotpris med aktiv prissikring og 100 % fornybar energi til norske bedrifter. Kun 3 øre i påslag og 49 kr i fast månedsavgift.",
    favicon: "/favicon.svg",
    email: "post@folketstrom.no",
    domain: "folketstrom.no",
    termsPdf: "/avtalevilkar-flexsikring.pdf",
    logoGradient: "from-emerald-400 via-teal-500 to-emerald-600",
    boltColor: "text-emerald-400",
    heroGlow: "bg-[radial-gradient(circle_at_30%_30%,rgba(16,185,129,0.2),transparent_70%)]",
    mapGradient: "from-slate-800 to-[#064E3B]",
    chartAccent: "#10B981",
    registration:
      "Vi er registrert i Foretaksregisteret under Rstrøm AS med markedsføringsnavn Folketstrøm, med hovedkontor i Oslo.",
    legalLine: "Registrert foretaksnavn: Rstrøm AS (markedsført som Folketstrøm).",
    copyright: "Copyright © 2026 Rstrøm AS (Folketstrøm). Alle rettigheter forbeholdt.",
  },
  rstrom: {
    id: "rstrom",
    cssClass: "brand-rstrom",
    name: "Rstrøm",
    companyLine: "Rstrøm AS",
    wordmarkTop: "R",
    wordmarkAccent: "STRØM",
    tagline: "Romerike Strøm",
    title: "Rstrøm AS | Romerike Strøm – Strøm på dine vilkår for bedrifter",
    description:
      "Rstrøm AS (Romerike Strøm) leverer Flexsikring – spotpris med aktiv prissikring og 100 % fornybar energi til norske bedrifter. Kun 3 øre i påslag og 49 kr i fast månedsavgift.",
    favicon: "/favicon-rstrom.svg",
    email: "post@rstrom.no",
    domain: "www.rstrom.no",
    termsPdf: "/avtalevilkar-flexsikring-rstrom.pdf",
    logoGradient: "from-sky-400 via-blue-500 to-blue-700",
    boltColor: "text-sky-400",
    heroGlow: "bg-[radial-gradient(circle_at_30%_30%,rgba(14,165,233,0.22),transparent_70%)]",
    mapGradient: "from-slate-800 to-[#0C4A6E]",
    chartAccent: "#0EA5E9",
    registration:
      "Rstrøm AS står for Romerike Strøm og er registrert i Foretaksregisteret, med hovedkontor i Oslo.",
    legalLine: "Rstrøm AS står for Romerike Strøm – registrert i Foretaksregisteret.",
    copyright: "Copyright © 2026 Rstrøm AS. Alle rettigheter forbeholdt.",
  },
};

const BrandContext = createContext(BRANDS.folketstrom);

export const BrandProvider = BrandContext.Provider;
export const useBrand = () => useContext(BrandContext);
